<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="option in question.options"
            :key="option.id"
            :class="['choice select-choice long-choice', { selected: isSelected(option.id, response)}]">
            {{ option.display_text }}
        </div>
        <template v-if="Array.isArray(response)">
            <div v-for="(resAns, index) in response"
                :key="index"
                :class="['choice select-choice long-choice selected', { hide: isSelected(resAns.id, question.options)}]">
                {{ resAns.display_text || resAns.value }}
            </div>
        </template>
    </div>
</template>

<script>

export default {   
    name: 'long-text-bubble-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Array,
		},
    },
    
    methods: {
        isSelected(optionId, resArr) {
            if(optionId && resArr && resArr.length > 0)
                return resArr.find((resObj) => resObj.id === optionId)
            return false
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
